import {
  mapState
} from "vuex";
export default {
  data() {
    return {
      isGettingAccounts: false,
      isGettingFloatAccounts: false,

      accountUsage: {
        PERSON: 'p',
        POS: 's',
        GATEWAY: 'g',
        BANK: 'b',
        DEPOSIT: 'd',
        IMPREST: 'i',
        OTHER: 'o',
      }
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.accounts,
      floatAccountGroups: state => state.floatAccountGroups,
      floatAccounts: state => state.floatAccounts,
      accountTypes: state => state.accountTypes,
      defaultAccounts: state => state.defaultAccounts,
      isGetting: state => state.isGetting
    }),
    accountsSelectValues() {
      this.log('Generate accountsSelectValues');
      let res = {
        levels: {
          0: [],
          1: [],
          2: [],
          3: [],
        },
        floatAccountGroups: [],
        floatAccounts: [],
        accountTypes: [],
        buyers: [],
        sellers: [],
        persons: [],
        banks: [],
        defaultAccounts: [],
        all: [],
      };
      if (!this.accounts) return res;

      this.accounts.forEach(account => {
        res.all.push(account);
        res.levels[account.level].push(account);

        if (account.account_type == 'p') {
          res.persons.push(account);
          if (account.person_type == 'buyer') res.buyers.push(account);
          if (account.person_type == 'seller') res.sellers.push(account);
        }

        if (account.account_type == 'b') res.banks.push(account);

      });

      this.accountTypes.forEach(at => {
        res.accountTypes.push({
          ...at,
        })
      })

      res.floatAccountGroups = this.floatAccountGroups;

      res.floatAccounts = this.floatAccounts;


      res.defaultAccounts.push({
        name: 'خنثی',
        id: null
      });

      this.defaultAccounts.forEach(da => {
        res.defaultAccounts.push({
          ...da,
        });
      });

      return res;
    },
    floatAccountTypes() {
      let types = [
        { key: 'floatAccount1', groupKey: 'floatAccount1Groups', text: 'حساب شناور یک' },
        { key: 'floatAccount2', groupKey: 'floatAccount2Groups', text: 'حساب شناور دو' },
        { key: 'floatAccount3', groupKey: 'floatAccount3Groups', text: 'حساب شناور سه' },
        { key: 'floatAccount4', groupKey: 'floatAccount4Groups', text: 'حساب شناور چهار' }
      ]

      types.forEach(type => {
        type.localKey = "local" + type.key.charAt(0).toUpperCase() + type.key.slice(1);
      })

      return types
    }
  },
  methods: {
    getActiveFinancialYearStartToEndYears(){
      let years = []
      if (parseInt(this.financialYear.start.slice(0,4)) == parseInt(this.financialYear.end.slice(0,4))){
        years.push(parseInt(this.financialYear.start.slice(0,4)))
      }
      else {
        let counter = parseInt(this.financialYear.end.slice(0,4)) - parseInt(this.financialYear.start.slice(0,4))
        while (counter >= 0){
          years.push(parseInt(this.financialYear.start.slice(0,4)) + counter)
          counter = counter - 1
        }
      }

      return years.sort()

    },
    getFinancialYearMonths() {
      let months = [
        {name: ' فروردین', value: '01', 'id': 1},
        {name: ' اردیبهشت', value: '02', 'id': 2},
        {name: ' خرداد', value: '03', 'id': 3},
        {name: ' تیر', value: '04', 'id': 4},
        {name: ' مرداد', value: '05', 'id': 5},
        {name: ' شهریور', value: '06', 'id': 6},
        {name: ' مهر', value: '07', 'id': 7},
        {name: ' آبان', value: '08', 'id': 8},
        {name: ' آذر', value: '09', 'id': 9},
        {name: ' دی', value: '10', 'id': 10},
        {name: ' بهمن', value: '11', 'id': 11},
        {name: ' اسفند', value: '12', 'id': 12},
      ];
      let months_day = {
        1: 31,
        2: 31,
        3: 31,
        4: 31,
        5: 31,
        6: 31,
        7: 30,
        8: 30,
        9: 30,
        10: 30,
        11: 30,
        12: 29,
      }

      let results = []
      let start = parseInt(this.financialYear.start.slice(0,4))
      let start_month = parseInt(this.financialYear.start.slice(5,7))
      let end = parseInt(this.financialYear.end.slice(0,4))
      let end_month = parseInt(this.financialYear.end.slice(5,7))

      for (let year of this.getActiveFinancialYearStartToEndYears()) {
        let current_year_months = []
        if (start == end) {
          for (let month of months) {
            if (month.id >= start_month && month.id <= end_month){
              current_year_months.push(month)
            }
          }
        } else if ( year != start && year != end) {
          current_year_months = months
        } else if ( year == start && year != end) {
          for (let month of months) {
            if (month.id >= start_month){
              current_year_months.push(month)
            }
          }
        } else if ( year != start && year == end) {
          for (let month of months) {
            if (month.id <= end_month){
              current_year_months.push(month)
            }
          }
        }
        for (let month of current_year_months){
          let month_start = this.toJDate(year + '/' + month.value + '/' + '01' )
          let month_end = this.toJDate(year + '/' + month.value + '/' + months_day[month.id] )
          results.push(
              {
                title: month.name + ' ' + year,
                start: this.toGDate(month_start),
                end: this.toGDate(month_end),
              }
          )
        }
      }
      return results
    },

    getSortedAccounts(accounts, reverse = false) {
      reverse = reverse ? 0 : 1

      accounts.sort((a, b) => b.id - a.id);

      accounts.sort((a, b) => a.code - b.code);
      let getChildren = (account) => {
        return accounts.filter(
          (o) => o.code.startsWith(account.code) && o.level == account.level + 1
        );
      };

      let sortedAccounts = accounts.filter((o) => o.level == 0);

      for (let i = 0; i < 3; i++) {
        for (let account of accounts.filter((o) => o.level == i)) {
          sortedAccounts.splice(
            sortedAccounts.indexOf(account) + reverse,
            0,
            ...getChildren(account)
          );
        }
      }
      return sortedAccounts;
    },
    getAccountFloatAccounts(account, groupKey) {
      let floatAccounts = []
      account[groupKey].forEach(floatAccountGroupId => {
        floatAccounts.push(
          ...this.floatAccounts.filter(
            o => o.floatAccountGroups.map(o => o.id).includes(floatAccountGroupId)
          )
        )
      })
      return floatAccounts;
    },
    getAccounts: async function (force = false, callback = null, loading = true) {
      if (!force && this.accounts.length) return;
      if (!this.canGet('accounts')) return;

      // const setFloatAccounts = (accounts) => {
      //   accounts.forEach(account => {
      //     this.floatAccountTypes.forEach(type => {
      //       account[type.groupKey] = this.getAccountFloatAccounts(account, type.type)
      //     })
      //   })
      // }

      return this.request({
        url: this.endpoint('accounts/accounts'),
        method: 'get',
        loading: loading,
        success: data => {
          // setFloatAccounts(data);
          this.$store.commit('setAccounts', data);
          callback && callback();
          this.EventBus.$emit('get:accounts');
          this.toggleIsGetting('accounts')
        }
      })
    },
    getFloatAccountGroups(force = false, callback = null) {
      if (!force && this.floatAccountGroups.length) return;
      if (!this.canGet('floatAccountGroups')) return;

      return this.request({
        url: this.endpoint("accounts/floatAccountGroups"),
        method: 'get',
        success: data => {
          this.$store.commit('setFloatAccountGroups', data);
          callback && callback()
          this.EventBus.$emit('get:accounts');
          this.toggleIsGetting('floatAccountGroups')
        }
      })
    },
    getFloatAccounts: async function (force = false, callback = null) {
      if (!force && this.floatAccounts.length) return;
      if (!this.canGet('floatAccounts')) return;

      return this.request({
        url: this.endpoint('accounts/floatAccounts'),
        method: 'get',
        success: data => {
          this.$store.commit('setFloatAccounts', data);
          callback && callback()
          this.EventBus.$emit('get:accounts');
          this.toggleIsGetting('floatAccounts')
        }
      })
    },
    getAccountTypes(force = false, init = false) {
      if (!force && this.accountTypes.length) return;
      if (!this.canGet('accountTypes')) return;

      return this.request({
        url: this.endpoint('accounts/accountTypes'),
        method: 'get',
        success: data => {
          this.$store.commit('setAccountTypes', data);
          init && this.init();
          this.toggleIsGetting('accountTypes')
        }
      })
    },
    getDefaultAccounts(force = false, init = false) {
      if (!force && this.defaultAccounts.length) return;
      if (!this.canGet('defaultAccounts')) return;

      return this.request({
        url: this.endpoint('accounts/defaultAccounts'),
        method: 'get',
        success: data => {
          this.$store.commit('setDefaultAccounts', data);
          init && this.init();
          this.toggleIsGetting('defaultAccounts')

          this.EventBus.$emit('get:defaultAccounts', data);
        }
      })
    },
    findAccount(property, value, accounts) {
      if (!accounts) accounts = this.accounts;
      for (const account of accounts) {
        if (account[property] == value) {
          return account;
        }
        if (account.children && account.children.length != 0) {
          let acc = this.findAccount(property, value, account.children);
          if (acc) return acc;
        }
      }
      return null;
    },
    getDefaultAccount(codename) {
      let res = this.defaultAccounts.filter(o => o.codename == codename);
      if (res.length) return res[0]
      return null
    },
    openLedger(account) {
      let routeData = this.$router.resolve({
        name: "LedgerReport",
        query: {
          'ledger.account': account.id,
          'ledger.level': `level${account.level}`
        }
      });
      window.open(
        routeData.href,
        "_blank",
      );
    },
    splitCode(code) {
      let res = [];
      let levelCodeLens = [1, 3, 5, 9];
      levelCodeLens.forEach(len => {
        let codePart = code.substr(0, len);
        if (!res.includes(codePart)) res.push(codePart);
      });
      return res;
    },
    accountParentsName(account) {
      if (!account || !account.code) return [];
      let res = [];
      let codes = this.splitCode(account.code);
      for (const code of codes) {
        let acc = this.findAccount("code", code);
        if (!acc) {
          continue;
        }
        res.push(acc.name);
        if (codes.indexOf(code) == code.length - 3) break;
      }
      return res;
    },

    getTitle(level, account_type = "o") {
      if (account_type == "b") return "تعریف حساب های خزانه > بانک";
      if (account_type == "r") return "تعریف اشخاص و جاری شرکا > جاری شرکا دریافتنی";
      if (account_type == "a") return "تعریف اشخاص و جاری شرکا > جاری شرکا پرداختنی";
      if (account_type == "s") return "تعریف حساب های خزانه > کارتخوان";
      if (account_type == "g") return "تعریف حساب های خزانه > درگاه بانکی";
      if (account_type == "d") return "تعریف حساب های خزانه > صندوق";
      if (account_type == "i") return "تعریف حساب های خزانه > تنخواه گردان";
      if (account_type == "p") return "تعریف اشخاص و جاری شرکا > اشخاص";
      switch (Number(level)) {
        case 0:
          return "تعریف سرفصل حساب > گروه";
        case 1:
          return "تعریف سرفصل حساب > کل";
        case 2:
          return "تعریف سرفصل حساب > معین";
        case 3:
          return "تعریف سرفصل حساب > تفصیلی";
      }
    },
    getLevelTitle(level, account_type = "o") {
      switch (Number(level)) {
        case 0:
          return "گروه";
        case 1:
          return "کل";
        case 2:
          return "معین";
        case 3:
          return "تفصیلی";
      }
    },
    hasFloatAccount(account, groupKey) {
      return this.getAccountFloatAccounts(account, groupKey).length != 0
    }
  },
}

export function fromCodeFilter(item, value) {
  if (!value) return true;
  for (let i = value.length; i < 9; i++) value += '0';
  switch (item.level) {
    case 0:
      return item.code >= value[0];
    case 1:
      return item.code >= value.substr(0, 3);
    case 2:
      return item.code >= value.substr(0, 5);
    case 3:
      return item.code >= value.substr(0, 9);
  }

}

export function toCodeFilter(item, value) {
  if (!value) return true;
  for (let i = value.length; i < 9; i++) value += '9';
  switch (item.level) {
    case 0:
      return item.code <= value[0];
    case 1:
      return item.code <= value.substr(0, 3);
    case 2:
      return item.code <= value.substr(0, 5);
    case 3:
      return item.code <= value.substr(0, 9);
  }
}